// Servicio de almacenamiento local (sessionStorage y localStorage)
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class StorageService {
  // ---- sessionStorage ----

  setSession<T>(key: string, value: T): void {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch {
      console.error(`Error al guardar en sessionStorage: ${key}`);
    }
  }

  getSession<T>(key: string): T | null {
    try {
      const item = sessionStorage.getItem(key);
      return item ? (JSON.parse(item) as T) : null;
    } catch {
      return null;
    }
  }

  removeSession(key: string): void {
    sessionStorage.removeItem(key);
  }

  clearSession(): void {
    sessionStorage.clear();
  }

  // ---- localStorage ----

  setLocal<T>(key: string, value: T): void {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      console.error(`Error al guardar en localStorage: ${key}`);
    }
  }

  getLocal<T>(key: string): T | null {
    try {
      const item = localStorage.getItem(key);
      return item ? (JSON.parse(item) as T) : null;
    } catch {
      return null;
    }
  }

  removeLocal(key: string): void {
    localStorage.removeItem(key);
  }
}
